<template>
  <div class="press mw-adjusted-align-center">
    <h2 class="light ctf-heading ctf-restrict">Article in the press</h2>
    <div class="banner-container">
      <a href="/press#mention-30"><div class="banner-col bloom"></div></a>
      <a href="/press#mention-26"><div class="banner-col newyorktimes"></div></a>
      <a href="/press#mention-27"><div class="banner-col forbes"></div></a>
      <a href="/press#mention-28"><div class="banner-col therapy"></div></a>
      <a href="/press#mention-1"><div class="banner-col cnbc"></div></a>
      <a href="/press#mention-2"><div class="banner-col globe"></div></a>
    </div>
    <div class="see-all-button">
      <a class="accent ctf-body" href="/press">See all press</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Press',
};
</script>

<style lang="postcss">
@import '@/pixel/style/variables';

.press {
  text-align: center;
  margin: var(--space-10) 0px;

  h4 {
    font-size: var(--font-size-24);
    line-height: var(--line-height-24);
    margin-bottom: var(--space-4);
  }

  .banner-container {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    margin-top: 4px;

    a {
      display: inline-block;
      flex: 1;

      @media (max-width: $tablet-breakpoint) {
        flex-basis: 30%;
      }

      .banner-col {
        width: 160px;
        height: 60px;
        margin: auto;

        &.bloom {
          background: url('https://cdn-images.article.com/assets/images/press/banner-sprite.png') no-repeat center 0px;
          background-size: 160px;
        }
        &.newyorktimes {
          background: url('https://cdn-images.article.com/assets/images/press/banner-sprite.png') no-repeat center -60px;
          background-size: 160px;
        }
        &.forbes {
          background: url('https://cdn-images.article.com/assets/images/press/banner-sprite.png') no-repeat center -120px;
          background-size: 160px;
        }
        &.therapy {
          background: url('https://cdn-images.article.com/assets/images/press/banner-sprite.png') no-repeat center -180px;
          background-size: 160px;
        }
        &.cnbc {
          background: url('https://cdn-images.article.com/assets/images/press/banner-sprite.png') no-repeat center -240px;
          background-size: 160px;
        }
        &.globe {
          background: url('https://cdn-images.article.com/assets/images/press/banner-sprite.png') no-repeat center -300px;
          background-size: 160px;
        }
      }
    }
  }

  .see-all-button {
    margin-top: var(--space-6);
  }
}
</style>
